export class Favorecido {
idFavorecido: number;
tipo?: string;
colaborador?: { idColaborador: number; };
fornecedor?: { idFornecedor: number; };
cliente?: { codigo: number; };
status?: string;
nome?: string;
}
